import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Col } from 'react-grid-system';
//import { prettyStandingsUrl, prettyCalendarUrl } from '../../../common/rcs_gaz_mc_core_FE';
import ConfigManager from '../../../common/configManager/configManager';
import Label from '../../../components/shared/Label';
//import StandingButton from '../../../components/shared/StandingButton';
import * as types from '../../../constants';
import {
  StandingWidgetWrapper, HeaderTable, CupWrapper,
  TitleWrapper, TableWrapper, TablesWrapper,
  //ButtonsWrapper,
} from './styles';
import StandingRowDashed from '../../../components/StandingRowDashed';

class StandingWidgetGazzanet extends Component {
  static childContextTypes = {
    breakpoints: PropTypes.arrayOf(PropTypes.number),
  };

  constructor(props) {
    super(props);
    this.state = {
      isMobile: false,
    };
  }

  getChildContext = () => ({
    breakpoints: [320, 600, 1024, 1440],
  });

  componentDidMount() {
    window.addEventListener('resize', this.resizeCallback);
    const interval = ConfigManager.getSportRefreshInterval(this.props.sportId) ? ConfigManager.getSportRefreshInterval(this.props.sportId) : 60000;
    this.sportTimer = setInterval(this.getStanding, interval);
    this.getStanding();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resizeCallback);
    if (this.sportTimer) {
      clearInterval(this.sportTimer);
    }
  }

  getStanding = () => {
    const {
      competitionId, sportId, actions, widgetId,
    } = this.props;
    actions.getStandings(sportId, competitionId, widgetId);
  };

  resizeCallback = () => {
    this.setState({
      isMobile: window.innerWidth <= 1023,
    });
  };

  render() {
    const {
      dictionary, standings, competitionId, widgetId, sportId, //isFootballSectionWrapper,
    } = this.props;
    const { isMobile } = this.state;
    const standing = standings[widgetId];
    return (
      <StandingWidgetWrapper isMobile={isMobile}>
        {standing && standing.competitionDay &&
        <TitleWrapper>
          <Label
            label={`${dictionary.competitionTable.competitionName[competitionId]} - ${standing.competitionDay}${dictionary.competitionTable.dayA}`}
            weight="bold"
            margin="0 0 16px"
            isCapitalize
            isTitleNarrowMedium
            size={0.9}
          />
        </TitleWrapper>
        }
        {competitionId === '6' || competitionId === '941' || competitionId === '5' ?
          <TablesWrapper>
            <TableWrapper>
              {standing && standing.contents && standing.contents.map((competition, index) => (
                <CupWrapper key={index}>
                  <HeaderTable className="has-background-primary ">
                    <Col md={6} sm={4.8} style={{ paddingLeft: '0' }}>
                      <Label
                        label={`Gruppo ${competition.competitionRoundId}`}
                        size={0.9}
                        color="white"
                        margin="0 0 0 4px"
                      />
                    </Col>
                    <Col
                      md={1}
                      sm={1.2}
                      style={{
              paddingLeft: 0,
              paddingRight: 0,
              display: 'flex',
              justifyContent: 'center',
            }}
                    >
                      <Label
                        label="G"
                        size={0.9}
                        color="white"
                      />
                    </Col>
                    <Col
                      md={1}
                      sm={1.2}
                      style={{
              paddingLeft: 0,
              paddingRight: 0,
              display: 'flex',
              justifyContent: 'center',
            }}
                    >
                      <Label
                        label="V"
                        size={0.9}
                        color="white"
                      />
                    </Col>
                    <Col
                      md={1}
                      sm={1.2}
                      style={{
              paddingLeft: 0,
              paddingRight: 0,
              display: 'flex',
              justifyContent: 'center',
            }}
                    >
                      <Label
                        label="N"
                        size={0.9}
                        color="white"
                      />
                    </Col>
                    <Col
                      md={1}
                      sm={1.2}
                      style={{
              paddingLeft: 0,
              paddingRight: 0,
              display: 'flex',
              justifyContent: 'center',
            }}
                    >
                      <Label
                        label="P"
                        size={0.9}
                        color="white"
                      />
                    </Col>
                    <Col
                      md={1}
                      sm={1.2}
                      style={{
              paddingLeft: 0,
              paddingRight: 0,
              display: 'flex',
              justifyContent: 'center',
            }}
                    >
                      <Label
                        label="DR"
                        size={0.9}
                        color="white"
                      />
                    </Col>
                    <Col
                      md={1}
                      sm={1.2}
                      style={{
              paddingLeft: 0,
              paddingRight: 0,
              display: 'flex',
              justifyContent: 'center',
            }}
                    >
                      <Label
                        label="Pt."
                        size={0.9}
                        color="white"
                      />
                    </Col>
                  </HeaderTable>
                  {competition.competitionTeams.map((match, singleIndex) => (
                    <StandingRowDashed
                      teamRow={match}
                      key={singleIndex}
                      competitionId={competitionId}
                      sportId={sportId}
                      isGazzanet
                    />
                  ))
                  }
                </CupWrapper>
              ))
              }
            </TableWrapper>
          </TablesWrapper>
          :
          <TablesWrapper>
            <TableWrapper>
              <HeaderTable className="has-background-primary">
                <Col
                  md={6}
                  sm={4.8}
                  style={{
                  paddingLeft: 0,
                  paddingRight: 0,
                }}
                />
                <Col
                  md={1}
                  sm={1.2}
                  style={{
                  paddingLeft: 0,
                  paddingRight: 0,
                  display: 'flex',
                  justifyContent: 'center',
                }}
                >
                  <Label
                    label="G"
                    size={0.9}
                    color="white"
                  />
                </Col>
                <Col
                  md={1}
                  sm={1.2}
                  style={{
                  paddingLeft: 0,
                  paddingRight: 0,
                  display: 'flex',
                  justifyContent: 'center',
                }}
                >
                  <Label
                    label="V"
                    size={0.9}
                    color="white"
                  />
                </Col>
                <Col
                  md={1}
                  sm={1.2}
                  style={{
                  paddingLeft: 0,
                  paddingRight: 0,
                  display: 'flex',
                  justifyContent: 'center',
                }}
                >
                  <Label
                    label="N"
                    size={0.9}
                    color="white"
                  />
                </Col>
                <Col
                  md={1}
                  sm={1.2}
                  style={{
                  paddingLeft: 0,
                  paddingRight: 0,
                  display: 'flex',
                  justifyContent: 'center',
                }}
                >
                  <Label
                    label="P"
                    size={0.9}
                    color="white"
                  />
                </Col>
                <Col
                  md={1}
                  sm={1.2}
                  style={{
                  paddingLeft: 0,
                  paddingRight: 0,
                  display: 'flex',
                  justifyContent: 'center',
                }}
                >
                  <Label
                    label="DR"
                    size={0.9}
                    color="white"
                  />
                </Col>
                <Col
                  md={1}
                  sm={1.2}
                  style={{
                  paddingLeft: 0,
                  paddingRight: 0,
                  display: 'flex',
                  justifyContent: 'center',
                }}
                >
                  <Label
                    label="Pt."
                    size={0.9}
                    color="white"
                  />
                </Col>
              </HeaderTable>
              {standing && standing.contents && standing.contents[0] &&
              standing.contents[0].competitionTeams.map((match, index) => (
                <StandingRowDashed
                  teamRow={match}
                  key={index}
                  competitionId={competitionId}
                  sportId={sportId}
                  isGazzanet
                />
              ))
              }
            </TableWrapper>
          </TablesWrapper>
        }
        {/* {!isFootballSectionWrapper &&
        <ButtonsWrapper>
          <StandingButton
            color="buttonColor"
            background="transparent"
            label="Classifica"
            borderColor="gray"
            linkTo={prettyStandingsUrl(sportId, competitionId, process.env.REACT_APP_SITE)}
            width="35%"
            margin="15px 0px 25px 0px"
            size="16px"
            isTitleNarrowMedium
          />
          <StandingButton
            color="buttonColor"
            background="transparent"
            label="Calendario e risultati"
            borderColor="gray"
            linkTo={prettyCalendarUrl(sportId, competitionId, process.env.REACT_APP_SITE)}
            width="60%"
            margin="15px 0px 25px 0px"
            size="16px"
            isTitleNarrowMedium
          />
        </ButtonsWrapper>
        }*/}
      </StandingWidgetWrapper>
    );
  }
}

StandingWidgetGazzanet.propTypes = {
  actions: PropTypes.any,
  standings: PropTypes.any,
  competitionId: PropTypes.any,
  sportId: PropTypes.any,
  dictionary: PropTypes.any,
  widgetId: PropTypes.any,
  //isFootballSectionWrapper: PropTypes.bool,
};

export default connect(
  state => ({
    dictionary: state.dictionaryReducer.dictionary,
    standings: state.standingReducer.standings,
  }),
  dispatch => ({
    actions: {
      initDictionary: () =>
        dispatch({ type: types.INIT_DICTIONARY }),
      getStandings: (sportId, competitionId, widgetId) =>
        dispatch({
          type: types.GET_STANDINGS_REQUEST,
          sportId,
          competitionId,
          widgetId,
        }),
    },
  }),
)(StandingWidgetGazzanet);



// WEBPACK FOOTER //
// ./src/containers/GazzanetWidgets/StandingWidgetGazzanet/index.js